import { Injectable } from '@angular/core';
import { PageService } from '../services/page.service'
import { UserRepository } from '../repositories/user.repository';
import { Constants } from '../constants/constants';
import { EventEmitter } from '@angular/core';
import { IUserFetchCriteriaModel } from '../entities-api/IUserFetchCriteriaModel';
import { IUserProfileDataModel } from '../entities-api/IUserProfileDataModel';
import { IGlobalEmployeeInfoModel } from '../entities-api/IGlobalEmployeeInfoModel';
import { IGlobalEmployeeOverrideModel } from '../entities-api/IGlobalEmployeeOverrideModel';
import { IGlobalEmployeeDetailGridDataModel } from '../entities-api/IGlobalEmployeeDetailGridDataModel';
import { IGlobalEmployeeDictionariesModel } from '../entities-api/IGlobalEmployeeDictionariesModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IBulkProfileModel } from '../entities-api/IBulkProfileModel';
import { IBulkProfileResultModel } from '../entities-api/IBulkProfileResultModel';
import { catchError, map } from 'rxjs/operators';
import { IAppcodeModel } from '../entities-api/IAppcodeModel';
import { IMfcodemodel } from '../entities-api/IMfcodemodel';
import { IContainerMappingDetailGridDataModel } from '../entities-api/IContainerMappingDetailGridDataModel';
import { IContainerMappingFetchCriteriaModel } from '../entities-api/IContainerMappingFetchCriteriaModel';
import { IGeocodemodel } from '../entities-api/IGeocodemodel';
import { IMfModel } from '../entities-api/IMfModel';
import { IBaseMappingFetchCriteriaModel } from '../entities-api/IBaseMappingFetchCriteriaModel';
import { IBaseMappingDetailGridDataModel } from '../entities-api/IBaseMappingDetailGridDataModel';
import { ContainerMappingRepository } from '../repositories/containermapping.repository';
import { IOnboardedAppGridModel } from '../entities-api/IOnboardedAppGridModel';
import { IOnBoardedAppFetchCriteriaModel } from '../entities-api/IOnBoardedAppFetchCriteriaModel';


@Injectable()
export class ContainermappingService {
  constructor(
    private userRepository: UserRepository,
    private page: PageService,
    private http: HttpClient,
    private ContainermappingRepository: ContainerMappingRepository
  ) {
    this.init();
  }

  private currentUser: Promise<IGlobalEmployeeInfoModel> = null;
  private cachedGridDataModel: IGlobalEmployeeDetailGridDataModel;
  private cachedGridDataModelcontainer: IContainerMappingDetailGridDataModel;
  private cachedGridDataModelbase: IBaseMappingDetailGridDataModel;
  private cachedGridDataModelapp: IOnboardedAppGridModel;
  private Constants = Constants;
  showUpdates: boolean = false;
  bellIconClickedEvent: EventEmitter<{}> = new EventEmitter();
  usersImagesCache = {};
  filter = <IUserFetchCriteriaModel>{}
  filerconatinermapping = <IContainerMappingFetchCriteriaModel>{}
  filterbasemapping = <IBaseMappingFetchCriteriaModel>{}
  filterOnBoarededApp = <IOnBoardedAppFetchCriteriaModel>{}
  mfmodel = <IMfModel>{}
  private init(): void {
    this.currentUser = this.ContainermappingRepository.getCurrentUserAsync();
  }
  getCurrentUserAsync(): Promise<IGlobalEmployeeInfoModel> {
    return this.currentUser;
  }
  getEnv(): Promise<string> {
    return this.userRepository.getEnv()
  }
  getContainermappings = (pageIndex: number = 0, isExcelDownload): Promise<IContainerMappingDetailGridDataModel> => {
    if (isExcelDownload) {
      this.filerconatinermapping.TopRows = 10000;
      this.filerconatinermapping.SkipRows = 0;
    } else {
      this.filerconatinermapping.TopRows = Constants.PagingConst.RecordsPerPage;
      this.filerconatinermapping.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    }
    pageIndex = this.page.currentPage;
    return this.ContainermappingRepository.getContainermappings(this.filerconatinermapping).then(
      (data: IContainerMappingDetailGridDataModel) => {
        this.cachedGridDataModelcontainer = data;
        return this.cachedGridDataModelcontainer;
      });
  }
  getAllContainerMappings = (): Promise<IContainerMappingDetailGridDataModel> => {
    return this.ContainermappingRepository.getAllContainermappings(this.filerconatinermapping).then(

      (data: IContainerMappingDetailGridDataModel) => {
        this.cachedGridDataModelcontainer = data;
        return this.cachedGridDataModelcontainer;
      });

  }
  getBasemappings = (pageIndex: number = 0, isExcelDownloaded): Promise<IBaseMappingDetailGridDataModel> => {
    if (isExcelDownloaded) {
      this.filterbasemapping.TopRows = 10000;
      this.filterbasemapping.SkipRows = 0;
    }
    else {
      this.filterbasemapping.TopRows = Constants.PagingConst.RecordsPerPage;
      this.filterbasemapping.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    }
    pageIndex = this.page.currentPage;
    return this.ContainermappingRepository.getBasemappings(this.filterbasemapping).then(
      (data: IBaseMappingDetailGridDataModel) => {
        this.cachedGridDataModelbase = data;
        return this.cachedGridDataModelbase;
      });
  }
  getappcodes(): Promise<IAppcodeModel> {
    return this.ContainermappingRepository.getappcodes();
  }

  getMfCodes(mfmodel: IMfModel): Promise<IMfcodemodel> {
    return this.ContainermappingRepository.getMfCodes(mfmodel);
  }
  getMfCodesBase(mfmodel: IMfModel): Promise<IMfcodemodel> {
    return this.ContainermappingRepository.getMfCodesBase(mfmodel);
  }
  getgeocodesBase(): Promise<IGeocodemodel> {
    return this.ContainermappingRepository.getgeocodesBase();
  }
  getgeocodes(): Promise<IGeocodemodel> {
    return this.ContainermappingRepository.getgeocodes();
  }
  getOnboardedApps(pageIndex: number = 0, isExcelEnabledDownload): Promise<IOnboardedAppGridModel> {
    if (isExcelEnabledDownload) {
      this.filterOnBoarededApp.TopRows = 1000;
      this.filerconatinermapping.SkipRows = 0;

    } else {
      this.filterOnBoarededApp.TopRows = Constants.PagingConst.RecordsPerPage;
      this.filterOnBoarededApp.SkipRows = pageIndex * Constants.PagingConst.RecordsPerPage;
    }
    pageIndex = this.page.currentPage;
    return this.ContainermappingRepository.getOnboardedApps(this.filterOnBoarededApp).then(
      (data: IOnboardedAppGridModel) => {
        this.cachedGridDataModelapp = data;
        return this.cachedGridDataModelapp;
      });;
  }
}
